import { Context, useLazyQuery, useMutation, useQuery, useSubscription } from "@apollo/client";
import bindOptions from "./bind-options";

export const modelsModuleString = "models";

export const publicAgreementsModuleString = "public agreements";

export const useModelsQuery = bindOptions(useQuery, (c) => ({ ...c, context: { module: modelsModuleString } })) as typeof useQuery;

export const useModelsMutation = bindOptions(
	useMutation,
	(c) => ({ ...c, context: { module: modelsModuleString } } as any)
) as typeof useMutation;

export const useModelsSubscription = bindOptions(useSubscription, (c) => ({ ...c, context: { module: modelsModuleString } } as any));

export const usePublicAgreementsQuery = bindOptions(useQuery, (c) => ({
	...c,
	context: { module: publicAgreementsModuleString },
})) as typeof useQuery;

export const useLazyModelsQuery = bindOptions(useLazyQuery, (c) => ({ ...c, context: { module: modelsModuleString } } as Context));
